<template>
  <form class="mt-2" id="form-modal">
    {{gettrialhistory}}
<table class="table table-bordered table-hover  mt-5 text-center">
            <colgroup>
              <col class="col-md-4" />
              <col class="col-md-12" />
            </colgroup>
            <tbody>
              <tr>
                <th>Created At</th>
                <th>Lead</th>
                <th>Assigned By</th>
                <th>Reason</th>
              </tr>
              
              <tr class="mt-2" v-for="(trial, index) in trial_history" :key="trial.id">
                <td  style="width: 20%;"> <p style="white-space: break-spaces">{{ trial.created_at | formatDate }}</p> </td>
                <td  style="width: 20%;"> <p style="white-space: break-spaces">{{ trial.company }}</p> </td>
                <td  style="width: 20%;"> <p style="white-space: break-spaces">{{ trial.user_name }}</p> </td>
                <td  style="width: 40%;"> <p style="white-space: break-spaces">{{ trial.reason }}</p> </td>
                
              </tr>
              <h5 style="text-align: center; position: absolute; transform: translateX(100px); margin-top: 24px;" v-if="trial_history.length<1">
      No Leads Transfer History.
    </h5>
            </tbody>
          </table>
  </form>
</template>

<script>
  import axios from "axios";
  import Multiselect from "vue-multiselect";
  import moment from "moment";
  Vue.filter("formatDate", function (value) {
    if (value != "0000-00-00 00:00:00" && value != null) {
      return moment(String(value)).format("MMM DD, Y LT");
    }
  });
  export default {
    components: {
      Multiselect
    },
    props: ["action", "formData", "pageNumber", "status"],
    data: function () {
      return {
       adminUsers: [],
       isMiniLoading: false,
       selected: "",
       note_description:"",
       trial_history:"",
      };
    },
    created: function () {
      const permission = {
        headers: {
          'X-Permission': 'lead_transfer_history' 
        }
      };
     axios.get('/admin/users/get-all-users-crm?role_id=' + 2,permission)
      .then((response) => {
        let res = response.data;
        this.adminUsers = res.data;
      });
    },
    computed :{
      gettrialhistory: function () {
        let lead_id = this.formData.lead_id;
         const permission = {
        headers: {
          'X-Permission': 'lead_transfer_history' 
        }
      };
        axios
          .get("/admin/users/get_transfer_leads?lead_id=" + lead_id,permission)
          .then((response) => {
            let data = response.data.trial_history;
            if (data != null) {
              this.trial_history = data;
            }
          });

      }

    },
    methods: {
      

    },
  };
</script>